export default __webpack_public_path__ + "static/media/padel-champions-logo.3a9d5862.png";